// frontend/src/components/code-editor/OutputPanel.tsx

import { RunResult } from '../../hooks/usePyodide';

interface OutputPanelProps {
  result: RunResult | null;
  pyodideLoading: boolean;
  pyodideError: string | null;
  onClear: () => void;
}

export function OutputPanel({ result, pyodideLoading, pyodideError, onClear }: OutputPanelProps) {
  return (
    <div className="card output-panel-card">
      <div className="output-panel-header">
        <h3>Çıktı</h3>
        <button type="button" className="lesson-btn secondary sm" onClick={onClear}>
          🗑️ Temizle
        </button>
      </div>

      <div className="output-panel-body">
        {pyodideLoading && (
          <span className="output-panel-muted">🐍 Python ortamı yükleniyor (ilk seferde birkaç saniye sürebilir)...</span>
        )}
        {pyodideError && <span className="output-panel-error">Python ortamı yüklenemedi: {pyodideError}</span>}

        {!pyodideLoading && !pyodideError && !result && (
          <span className="output-panel-muted">Kodu çalıştırmak için "Çalıştır" butonuna tıkla...</span>
        )}

        {result && (
          <>
            {result.output && <pre className="output-panel-stdout">{result.output}</pre>}
            {result.error && <pre className="output-panel-stderr">{result.error}</pre>}
            {!result.output && !result.error && (
              <span className="output-panel-muted">(Çıktı yok — kod çalıştı ama ekrana bir şey yazdırmadı)</span>
            )}
            <div className="output-panel-meta">⏱️ {result.durationMs}ms sürdü</div>
          </>
        )}
      </div>
    </div>
  );
}
